import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_rel_option = _resolveComponent("ontos-rel-option")!
  const _component_ontos_rel_selection = _resolveComponent("ontos-rel-selection")!
  const _component_ontos_creatable_autocomplete = _resolveComponent("ontos-creatable-autocomplete")!

  return (_openBlock(), _createBlock(_component_ontos_creatable_autocomplete, {
    label: _ctx.hideLabel? undefined : _ctx.property.name,
    items: _ctx.items,
    "item-title": "_identifier",
    "item-value": "_instance",
    readonly: _ctx.readonly,
    multiple: _ctx.isMultiple,
    "item-props": _ctx.itemProps,
    "auto-select-first": "",
    "onUpdate:modelValue": _ctx.onChange,
    variant: (_ctx.outlined) ? 'outlined' : undefined,
    density: _ctx.dense ? 'compact' : undefined,
    "model-value": _ctx.value,
    "error-messages": _ctx.errorMessage,
    hint: _ctx.hint,
    "persistent-hint": !!_ctx.hint,
    creatable: _ctx.creatable,
    onCreate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create', $event)))
  }, {
    item: _withCtx(({item, props}) => [
      _createVNode(_component_ontos_rel_option, _mergeProps(props, {
        item: item,
        density: _ctx.dense ? 'compact' : undefined
      }), null, 16, ["item", "density"])
    ]),
    selection: _withCtx(({item}) => [
      _createVNode(_component_ontos_rel_selection, {
        item: item,
        removable: _ctx.canRemove,
        onRemove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.remove($event)))
      }, null, 8, ["item", "removable"])
    ]),
    _: 1
  }, 8, ["label", "items", "readonly", "multiple", "item-props", "onUpdate:modelValue", "variant", "density", "model-value", "error-messages", "hint", "persistent-hint", "creatable"]))
}